import { Box, Grid, Stack, Typography } from "@mui/material";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { AddOnItemName } from "schemas/dashboard";

import CardWrapper from "../components/CardWrapper";
import CreditPacks from "./CreditPacks";
import CreditsHeader from "./CreditsHeader";
import styles from "./styles";

const AddOnsCredits = () => {
  const { subscription, addOns } = useContext(SubscriptionContext);

  if (!addOns?.[AddOnItemName.ai_credits_750]) {
    return <></>;
  }

  const balance = subscription?.remainingChatMessages ?? 0;

  return (
    <CardWrapper>
      <Grid item>
        <CreditsHeader />

        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
          sx={styles.balanceCard}
        >
          <Box sx={styles.balanceLeft}>
            <Typography sx={styles.balanceLabel}>
              Your credit balance
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Used for AI features across Bento
            </Typography>
          </Box>
          <Box sx={styles.balanceRight}>
            <Typography sx={styles.balanceValue}>{balance}</Typography>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={styles.balanceUnit}
            >
              credits left
            </Typography>
          </Box>
        </Stack>

        <CreditPacks />
      </Grid>
    </CardWrapper>
  );
};

export default AddOnsCredits;
